
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case/[id]",
      function () {
        return require("private-next-pages/case/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case/[id]"])
      });
    }
  